<template>
    <v-app>
        <Navbar />
        <router-view />
        <Footer />
    </v-app>
</template>

<script>
    import Navbar from '@/components/layout/Navbar'
    import Footer from '@/components/layout/Footer'

    export default {
        components: {
            Footer,
            Navbar
        },
        mounted() {
            if (window.localStorage.getItem('locale')) {
                this.$i18n.locale = window.localStorage.getItem('locale')
            } else {
                this.$i18n.locale = navigator.language.split('-')[0];
            }
        }
    }
</script>

<style lang="sass">
    html, body
        margin: 0
        padding: 0
        height: auto
        min-height: 100%
        overflow-x: hidden
        max-width: 100vw

    img
        max-width: 100%
        height: auto

    video:not(.hero-video-fill)
        max-width: 100%
        height: auto

    picture
        max-width: 100%

    .v-application
        font-family: Raleway, serif
        overflow-x: hidden
        max-width: 100vw

        &::-webkit-scrollbar
            width: 5px

    html
        scroll-behavior: smooth

    .slide-fade-enter-active
        transition: all 3s ease

    .slide-fade-leave-active
        transition: all .3s ease

    .slide-fade-enter-to
        position: absolute
        right: 0

    .slide-fade-enter-from
        position: absolute
        opacity: .5

    .slide-fade-enter
        position: absolute
        opacity: 1

    .slide-fade-leave-to
        opacity: .5
</style>
